const handRaisedMetadataKey = 'geoescala_hand_raised';

const metadataRecord = (metadata?: unknown): Record<string, unknown> => {
  if (!metadata) return {};
  if (typeof metadata === 'string') {
    try {
      const parsed = JSON.parse(metadata) as unknown;
      return parsed && typeof parsed === 'object'
        ? (parsed as Record<string, unknown>)
        : {};
    } catch {
      return {};
    }
  }
  return metadata && typeof metadata === 'object'
    ? (metadata as Record<string, unknown>)
    : {};
};

export const participantHasRaisedHand = (metadata?: unknown) =>
  metadataRecord(metadata)[handRaisedMetadataKey] === true;

export const participantMetadataWithRaisedHand = (
  metadata: unknown,
  raised: boolean,
) => {
  const nextMetadata = { ...metadataRecord(metadata) };
  if (raised) {
    nextMetadata[handRaisedMetadataKey] = true;
  } else {
    delete nextMetadata[handRaisedMetadataKey];
  }
  return JSON.stringify(nextMetadata);
};
